<template>
  <div class='checkbox-button-select'>
    <b-field>
        <template v-if='label' #label>
          <label class='label'>{{ label }}</label>
        </template>

        <b-checkbox-button
          v-for='option in options'
          v-model='selected'
          :native-value='option.value'
          @input="$emit('input', selected)">

          {{ option.label ? option.label : option.value }}
        </b-checkbox-button>
    </b-field>
  </div>
</template>



<script>
  //import SubComponent from '../components/SubComponent'

  export default {
      name: 'component-name',
      components: { /* Subcomponents */ },
      props: ['options', 'default', 'label'],
      data() { return {
        selected: []
      }},
      beforeCreate() {},
      created() {},
      mounted() {
        if(this.default !== undefined) this.selected = this.default
      },
      updated() {},
      computed: { /*
          Creates a new property
          Updates when any dependant property changes */
      },
      watch: { /*
          Watches an existing property
          Only runs when the watched property changes */
      },
      methods: {}
  }
</script>



<style scoped>

</style>